<template>
    <el-button type="primary" v-if="loading" icon="el-icon-loading" disabled></el-button>
    <el-button type="primary" @click="onSubmit" v-else>确认</el-button>
</template>
<script>
import bus from './bus';
export default {
    name: 'submitBtn',
    created() {
        // 接收http.js文件传来的通知
        bus.$on('btnStatus', (msg) => {
            this.loading = msg;
        });
        // 接收保存按钮toJSON方法里面的isOnsubmit的值，当toJSON方法不通过，不想走提交接口的时候
        bus.$on('isOnsubmit', (msg) => {
            this.isOnsubmit = msg;
        });     
    },
    data() {
        return {
            loading: false,
            isOnsubmit: true
        };
    },
    props: {
        // 发送数据
        data: {},
        // 验证规则
        rules: {},
        // 请求路径
        url: '',
        // 是否需要数据转换
        JSON_Boolean: Boolean
    },
    methods: {
        // 提交
        onSubmit() {
            this.loading = true;
            if (this.JSON_Boolean) {
                // JSON_Boolean是添加页面保存按钮传递过来的参数，如果为true 则走toJSON里面的方法
                this.$emit('toJSON');
            }           
            if (this.isOnsubmit == true) {     
                //isOnsubmit 默认为true，所以如果页面没有toJSON方法，默认走下面代码，如果页面的toJSON方法  改变isOnsubmit为false，则不走下面的提交接口，无法提交数据        
                this.$nextTick(() => {                    
                    this.$post(this.url, this.data, this.rules).then((res) => {                    
                        this.$message.success(res.msg);
                        // 触发父组件自定义事件刷新表格
                        this.$emit('onSubmitDig');
                        this.loading = false;
                        
                    });
                });
            }
        }
    }
};
</script>

<style scoped>
</style>